import React from 'react';
import { motion } from 'framer-motion';
const galleryImages = ['https://cdn.magicpatterns.com/uploads/2W5MquAF11cS9NmPTsWQ1g/image.png', 'https://cdn.magicpatterns.com/uploads/nqueGCPVjRfVtGA7iDxeQV/image.png', 'https://cdn.magicpatterns.com/uploads/7bo8yHE4JUrzt7we1wUgUv/image.png', 'https://cdn.magicpatterns.com/uploads/cHhmxumrxMjNCnfFEwaRQd/image.png', 'https://cdn.magicpatterns.com/uploads/8GnLrPZhP2cRxxVkQVrfNL/image.png', 'https://cdn.magicpatterns.com/uploads/g97e5pKh6TwNvssVjSthec/image.png', 'https://cdn.magicpatterns.com/uploads/j78y35iY8mpMFYcuesfLWf/image.png'];
export function Gallery() {
  return <section className="py-16 md:py-20 bg-brand-black text-white" data-id="element-147">
      <div className="max-w-7xl mx-auto px-6" data-id="element-148">
        <div className="text-center mb-12" data-id="element-149">
          <h2 className="text-4xl md:text-5xl font-serif mb-4 text-brand-gold" data-id="element-150">
            Events in Action
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-151">
            A glimpse into the unforgettable experiences we create for our
            clients across the DMV area.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 auto-rows-[250px]" data-id="element-152">
          {galleryImages.map((img, index) => {
          // Determine grid placement for a magazine-style layout
          let spanClasses = 'md:col-span-1 md:row-span-1';
          if (index === 0) spanClasses = 'md:col-span-2 md:row-span-2'; // Large feature image top left
          if (index === 4) spanClasses = 'md:col-span-2 md:row-span-1'; // Wide image in the middle
          if (index === 6) spanClasses = 'md:col-span-2 md:row-span-1'; // Wide image at the bottom
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`relative overflow-hidden rounded-sm group ${spanClasses} h-64 md:h-auto`} data-id="element-153">
                <img src={img} alt={`Catering Event ${index + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-154" />
                <div className="absolute inset-0 bg-brand-black/20 group-hover:bg-transparent transition-colors duration-500" data-id="element-155" />
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}